import React from 'react';

export default class Footer extends React.Component {
    render(){
        return (
            <div style={{width:"100%", backgroundColor:"#5e5550",padding:"8px"}}></div>
        );
    }
}